module.exports = __webpack_public_path__ + "static/media/halo-clean.cbee7248.webp";